import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { ToastType } from "../../../../ToastManager/constants";
import { sendNotification } from "../../../../ToastManager/ToastManager";
import {
  mapDispatchToProps,
  mapStateToProps,
  surveyAnalyticsReducer,
} from "./SurveyAnalytics.store";
import { VisualizationPanel } from "survey-analytics";
import "survey-analytics/survey.analytics.css";
import "jquery-ui/themes/base/all.css";

import * as Survey from "survey-react";

const StyledSurveyAnalytics = styled.div`
  border-radius: 5px;
  padding: 4rem;
  margin-top: 25px;

  & > h6 {
    font-weight: 100;
    margin-top: 15px;
  }
`;
export const SurveyAnalytics = (props) => {
  const {
    allQuestions,
    questionList,
    surveyDefinitionCmsId,
    surveyDefinitionCmsVersion,
    widgetId,
    resetState,
    fetchSurveyModel,
    fetchSurveyAnalyticsData,
  } = props;

  const { surveyAnalyticsData, surveyDefinition, surveyAnswers } = props;

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  //Get answers & answers data for surveyDefinitionCmsId && surveyDefinitionCmsVersion
  useEffect(() => {
    if (
      !surveyAnalyticsData &&
      surveyDefinitionCmsId &&
      surveyDefinitionCmsVersion
    ) {
      fetchSurveyAnalyticsData(
        surveyDefinitionCmsId,
        surveyDefinitionCmsVersion,
        widgetId
      )
        .then((svid) => {
          "Obtained Analytics Data", svid;
          fetchSurveyModel(svid, widgetId);
        })
        .catch((e) => sendNotification(e, ToastType.ERROR));
    }
  }, []);

  return (
    <StyledSurveyAnalytics>
      <h3>{`${surveyDefinition?.title || "Loading..."}`}</h3>
      <h6>*Not all participants answered all questions.</h6>
      <SurveyAnalyticsRenderer
        {...{ surveyDefinitionCmsId }}
        {...{ surveyDefinition }}
        {...{ surveyAnswers }}
        {...{ allQuestions }}
        {...{ questionList }}
      />
    </StyledSurveyAnalytics>
  );
};

const SurveyAnalyticsRenderer = ({
  surveyDefinition,
  surveyAnswers,
  allQuestions,
  questionList,
}) => {
  const survey = new Survey.Model(surveyDefinition?.model);
  let theme = Survey.StylesManager.ThemeColors["default"];
  theme["$main-color"] = "#a7208c";
  Survey.StylesManager.applyTheme(theme);
  const surveyEl = useRef(null);
  const visPanel = new VisualizationPanel(
    allQuestions
      ? survey.getAllQuestions()
      : survey.getAllQuestions().filter((q, i) => questionList.includes(i)),
    surveyAnswers,
    {
      allowChangeAnswersOrder: true,
      allowShowPercentages: true,
      allowHideEmptyAnswers: false,
      allowTransposeData: false,
      allowTopNAnswers: true,
      "UCID-8_SPN-5_USID-2": {
        intervals: [
          { start: 0, end: 5, label: "Infant" },
          { start: 5, end: 13, label: "Child" },
          { start: 13, end: 18, label: "Adolescent" },
          { start: 18, end: 111, label: "Adult" },
        ],
      },
    }
  );
  visPanel.showHeader = false;
  useEffect(() => {
    visPanel.render(surveyEl.current);
  });
  return (
    <div id="surveyAnalyticsContainer" ref={surveyEl}>
      {surveyDefinition && surveyAnswers ? "" : "Generating visualizations..."}
    </div>
  );
};

export default dynamic(
  "surveyAnalyticsReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(surveyAnalyticsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SurveyAnalytics));
